// extracted by mini-css-extract-plugin
module.exports = {"flashNewsTit":"index_flashNewsTit__4LkNR","tabsCon":"index_tabsCon__xN_fQ","tabsConBox":"index_tabsConBox__gvJ6B"};